import { Loadable } from '../../Loadable';

export const AsyncOptionGroups = Loadable(() => import('./List'));
export const AsyncAddOptionGroup = Loadable(() => import('./Add'));
export const AsyncEditOptionGroup = Loadable(() => import('./Edit'));
